<template>
  <el-row id="item" class="bg-blue-50 p-3 rounded-md flex items-center">
    <el-col :span="14" class="font-semibold">
      {{ guia.nome }}
    </el-col>
    <el-col :span="5" class="font-date text-primary flex items-center justify-start">
      <i class="el-icon-time ml-1"></i>
      {{ formatDate(guia.data_publicado) }}
    </el-col>
    <el-col :span="5" class="flex items-center justify-end">
      <el-button
        class="justify-end custom-download-button font-bold text-primary"
        @click="handleDownload"
        type="text"
      >
        DOWNLOAD
        <i class="el-icon-download button-icon"></i>
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Func4GuiaImpressoItem',
  computed: {
    ...mapState('SetupApp', ['esquemaDeCor'])
  },
  props: {
    guia: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('pt-BR', options)
    },
    async handleDownload () {
      const urlBase = process.env.VUE_APP_IMAGE_BUCKET
      const url = this.guia.livreto_url
      const assetsIndex = url.indexOf('assets')
      const result = url.substring(assetsIndex + 'assets'.length)
      const urlFinal = urlBase + result

      const element = document.createElement('a')
      element.setAttribute('href', urlFinal)
      element.setAttribute('target', '_blank')
      element.click()
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.rounded-md {
  border-radius: .5rem;
}

.bg-blue-50 {
  background-color: var(--cor-primaria-aplicacao-transparent);
}

.p-3 {
  padding: 1.5rem;
}

.font-semibold {
  font: normal normal 600 14px Open Sans;
}

.font-bold {
  font: normal normal 700 12px Open Sans;
}

.font-date {
  font: normal normal 12px Open Sans;
}

.text-primary {
  color: var(--cor-primaria-aplicacao);
}

.items-center {
  align-items: center;
}

.ml-1 {
  margin-right: 5px;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.custom-download-button {
  font-size: 12px;
  font-weight: bold;
}

.custom-download-button .button-icon {
  margin-left: 5px;
}
</style>
